import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../config';

const SchemaVersionsExpandable = ({ schema }) => {
  const { token } = useAuth();
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadVersions();
  }, [schema.id]);

  const loadVersions = async () => {
    setLoading(true);
    try {
      const headers = {};
      if (token) headers['Authorization'] = `Bearer ${token}`;
      const apiKey = localStorage.getItem('vaultize_api_key');
      const tenantUid = localStorage.getItem('vaultize_tenant_uid');
      if (apiKey) headers['X-API-KEY'] = apiKey;
      if (tenantUid) headers['X-TENANT-ID'] = tenantUid;

      const res = await fetch(
        `${API_BASE}/admin/schemas/${schema.id}/versions?page=0&pageSize=10`,
        { headers }
      );

      if (!res.ok) throw new Error('Failed to load versions');

      const data = await res.json();
      setVersions(data.content || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading versions...</div>;
  if (error) return <div className="schema-error">{error}</div>;
  if (versions.length === 0) return <div>No versions found</div>;

  return (
    <div className="versions-panel">
      {versions.map((v) => (
        <details key={v.id} className="version-item">
          <summary>
            <strong>v{v.version}</strong> —{' '}
            {new Date(v.createdAt).toLocaleString()}
          </summary>

          <pre className="schema-json-display">
            {JSON.stringify(JSON.parse(v.definition), null, 2)}
          </pre>
        </details>
      ))}
    </div>
  );
};

export default SchemaVersionsExpandable;
